module.exports = __webpack_public_path__ + "img/icon-by-empty-white.8720a520.svg";